<template>
  <div class="h-full overflow-auto">
    <CategoryTitle class="mt-5px" title="专业统计"></CategoryTitle>
    <barchart :values="professionStatistics"></barchart>
    <CategoryTitle class="mt-5px" title="缺陷类型统计"></CategoryTitle>
    <piechart :values="defectTypeStatistics"></piechart>
    <div class="flex justify-between mt-5px">
      <CategoryTitle class="mt-5px" title="缺陷列表"></CategoryTitle>
      <div
        class="
          btn-bg
          text-14px text-white
          h-28px
          leading-28px
          pl-10px
          pr-10px
          align-center
          rounded-5px
          cursor-pointer
        "
        @click="showMore"
      >
        更多
      </div>
    </div>
    <el-table :data="dataList" style="width: 100%" v-loading="tableLoading">
      <el-table-column prop="defect_desc" show-overflow-tooltip label="缺陷描述"> </el-table-column>
      <el-table-column prop="bgrqort_data" label="报告日期"> </el-table-column>
      <el-table-column prop="defect_code" label="状态"> </el-table-column>
      <el-table-column label="操作" width="75px">
        <template #default="{ row }">
          <div @click.stop="getBasicInfo(row)" class="cursor-pointer">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 缺陷清单 -->
    <defectList
      v-show="showDefectDialog"
      @openDetail="getBasicInfo"
      @close="showDefectDialog = false"
      :player="player"
      class="w-1000px h-600px"
      @refresh="refresh"
    />
  </div>
</template>
<script>
import axios from 'axios'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import barchart from './components/barchart'
import piechart from './components/piechart'
import { token1 } from './constant'

const defectList = () => {
  return import('./components/defectList')
}
const baseUrl = Wiz.GetModuleServer()
export default {
  name: 'cockpit-defect-manage',
  components: {
    barchart,
    piechart,
    defectList,
    CategoryTitle,
  },
  props: {
    player: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      professionStatistics: [], // 专业统计
      defectTypeStatistics: [], // 缺陷类型
      showDefectDialog: false,
      tableLoading: false,
      dataList: [], // 缺陷列表数据
    }
  },
  mounted() {
    this.getList()
    this.getProfessionalInfo()
    this.getDefectTypeInfo()
    this.player.Native.ModelTree.EventSelectItemChanged.connect((e) => {
      console.log(e, '点选模型了')
      this.getList(e?.code)
    })
  },
  methods: {
    // 更多
    showMore() {
      this.showDefectDialog = true
    },
    // 缺陷列表数据
    getList(kksCode) {
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/uf_defect_login_limit/V1.0?token=${token1}&kks_code=${
          kksCode || ''
        }`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          console.log(res)
          this.dataList = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 查看详情
    viewDetail(row) {
      this.$emit('transferEvent', {
        toCom: { code: 'DefectDetail', origin: 'defectManage', name: '缺陷详情' },
        type: 'mainComponent',
        props: {
          ...row,
          openAlarmFlicker: false,
        },
      })
    },
    // 获取缺陷基本信息
    getBasicInfo(row) {
      // this.viewDetail(row) // 临时调试代码，用完删除
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/uf_defect_login/V1.0.1.1.1?token=${token1}&defect_login_code=${row.defect_login_code}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          console.log(res)
          if (res && res.data.data && res.data.data.items[0]) {
            // 获取消缺信息
            this.getWorkOrderInfo(row, res.data.data.items[0])
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取消缺信息
    getWorkOrderInfo(row, basicInfo) {
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/uf_defect_work_order/V1.0?token=${token1}&work_order_number=${row.defect_login_code}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          console.log(res)
          if (res && res.data.data && res.data.data[0]) {
            this.viewDetail({
              ...res.data.data[0],
              ...basicInfo,
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 专业统计
    getProfessionalInfo() {
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/uf_defect_login_speciality/V1.0?token=${token1}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          console.log(res)
          this.professionStatistics = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 缺陷类型统计
    getDefectTypeInfo() {
      axios({
        method: 'GET',
        url: `${baseUrl}/openapi/uf_defect_login_work_type/V1.0?token=${token1}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          console.log(res)
          this.defectTypeStatistics = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 刷新
    refresh(val) {
      this.showDefectDialog = false
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bg {
  background-color: var(--cockpitTabsActiveColor) !important;
  line-height: 28px !important;
}
</style>
